export default __webpack_public_path__ + "static/media/chart.3f1bd1b0.png";